module.exports = __webpack_public_path__ + "img/consult_banner.fda36f77.jpg";